if (!customElements.get('image-text-heading-block-v1')) {
  customElements.define('image-text-heading-block-v1',
    class ImageTextHeadingBlock extends HTMLElement {
      constructor() {
        super();
        this.swiper = null;
        this.defaultDesktopSrcs = [];
        this.defaultMobileSrcs = [];
      }

      connectedCallback() {
        this.initSwiper();
        this.handleResize = this.handleResize.bind(this);
        window.addEventListener('resize', this.handleResize);
        this.updateFromCurrentVariantSelection = this.updateFromCurrentVariantSelection.bind(this);
        document.addEventListener('renderSection:complete', this.updateFromCurrentVariantSelection);
        this.captureDefaultImages();
        this.updateFromCurrentVariantSelection();
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.handleResize);
        this.destroySwiper();
        document.removeEventListener('renderSection:complete', this.updateFromCurrentVariantSelection);
      }

      initSwiper() {
        if (!(window.innerWidth <= 1024) || this.swiper !== null || !window.Swiper) {
          return;
        }

        const swiperContainer = this.querySelector('.swiper-container');
        if (!swiperContainer) {
          return;
        }

        const slides = this.querySelectorAll('.swiper-slide');
        if (slides.length === 0) {
          return;
        }

        const showMobileNavigation = (swiperContainer.closest('.image-text-heading-block')?.dataset.showMobileNavigation === 'true');

        const swiperOptions = {
          slidesPerView: 1, // Strictly show one slide per view
          centeredSlides: false, // Ensure slides are not centered
          initialSlide: 0,
          speed: 800,
          autoHeight: false,
          updateOnWindowResize: true,
          pagination: {
            el: this.querySelector('.image-text-heading-block__mobile-slider .swiper-pagination'),
            clickable: true,
            bulletClass: 'swiper-pagination-bullet',
            bulletActiveClass: 'swiper-pagination-bullet-active',
            renderBullet(index, className) {
              return `<span class="${className}" aria-label="Slide ${index + 1}"></span>`;
            },
            type: 'bullets',
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          loop: true,
          allowSlidePrev: true,
          grabCursor: true,
          touchEventsTarget: 'container',
          touchRatio: 1,
          longSwipesRatio: 0.5,
          followFinger: true,
          a11y: {
            enabled: true,
            prevSlideMessage: 'Previous slide',
            nextSlideMessage: 'Next slide',
            firstSlideMessage: 'This is the first slide',
            lastSlideMessage: 'This is the last slide',
            paginationBulletMessage: 'Go to slide {{index}}',
          },
        };

        this.swiper = new window.Swiper(swiperContainer, swiperOptions);

        const setEqualHeights = () => {
          const allSlides = this.querySelectorAll('.swiper-slide');
          if (allSlides.length <= 1) return;

          allSlides.forEach(slide => {
            slide.style.height = 'auto';
          });

          let maxHeight = 0;
          allSlides.forEach(slide => {
            const slideHeight = slide.offsetHeight;
            maxHeight = Math.max(maxHeight, slideHeight);
          });

          if (maxHeight > 0) {
            allSlides.forEach(slide => {
              slide.style.height = `${maxHeight}px`;
            });
          }
        };

        this.swiper.on('init', () => {
          setTimeout(setEqualHeights, 100);
          this.swiper.update();
        });

        this.querySelectorAll('.swiper-slide img').forEach(img => {
          img.addEventListener('load', () => {
            setEqualHeights();
            this.swiper.update();
          });
        });

        if (!showMobileNavigation) {
          const navButtons = this.querySelectorAll('.swiper-button-prev, .swiper-button-next');
          navButtons.forEach((button) => {
            button.style.display = 'none';
          });
        }

        const statusElement = this.querySelector('.current-slide-status');

        this.swiper.on('slideChange', () => {
          const activeIndex = this.swiper.activeIndex;
          const totalSlides = this.swiper.slides.length;

          if (statusElement) {
            statusElement.textContent = `Slide ${activeIndex + 1} of ${totalSlides}`;
          }
        });
      }

      destroySwiper() {
        if (!this.swiper) {
          return;
        }

        this.swiper.destroy(true, true);
        this.swiper = null;
      }

      captureDefaultImages() {
        const scopedRoot = this;
        const desktopImages = scopedRoot.querySelectorAll('.image-text-heading-block__desktop .card_item .image-text-heading-block__image');
        const mobileImages = scopedRoot.querySelectorAll('.image-text-heading-block__mobile-slider .image-text-heading-block__image');
        this.defaultDesktopSrcs = Array.from(desktopImages).map((img) => img.src);
        this.defaultMobileSrcs = Array.from(mobileImages).map((img) => img.src);
      }

      handleResize() {
        if (window.innerWidth <= 1023) {
          if (!this.swiper) {
            this.initSwiper();
          }
        } else {
          this.destroySwiper();
        }
      }
      getSelectedVariantImageUrls() {
        const productInfo = document.querySelector('product-info');
        if (!productInfo) return [];
        const variantSelector = productInfo.querySelector('variant-selector');
        if (!variantSelector) return [];
        const selectedOptionWithFiles = variantSelector.querySelector('select option:checked[data-variant-file]');
        const checkedRadioWithFiles = variantSelector.querySelector('input[type="radio"][data-variant-file]:checked');
        const dataValue = (selectedOptionWithFiles?.dataset?.variantFile) || (checkedRadioWithFiles?.dataset?.variantFile) || '';
        if (!dataValue) return [];
        return dataValue.split(',').map((s) => s.trim()).filter(Boolean);
      }

      updateImages(urls) {
        const hasVariantImages = Array.isArray(urls) && urls.length > 0;
        const scopedRoot = this;
        const desktopImages = scopedRoot.querySelectorAll('.image-text-heading-block__desktop .card_item .image-text-heading-block__image');
        desktopImages.forEach((img, index) => {
          if (hasVariantImages) {
            const mappedIndex = index % urls.length;
            img.src = urls[mappedIndex] || img.src;
          } else if (this.defaultDesktopSrcs.length) {
            const mappedIndex = index % this.defaultDesktopSrcs.length;
            img.src = this.defaultDesktopSrcs[mappedIndex] || img.src;
          }
        });
        const mobileImages = scopedRoot.querySelectorAll('.image-text-heading-block__mobile-slider .image-text-heading-block__image');
        mobileImages.forEach((img, index) => {
          if (hasVariantImages) {
            const mappedIndex = index % urls.length;
            img.src = urls[mappedIndex] || img.src;
          } else if (this.defaultMobileSrcs.length) {
            const mappedIndex = index % this.defaultMobileSrcs.length;
            img.src = this.defaultMobileSrcs[mappedIndex] || img.src;
          }
        });
        if (this.swiper) {
          setTimeout(() => {
            this.swiper.updateSlides?.();
            this.swiper.update?.();
          }, 100);
        }
      }
      updateFromCurrentVariantSelection() {
        const urls = this.getSelectedVariantImageUrls();
        this.updateImages(urls);
      }
    }
  );
}
